import React from 'react';
import useDashboardStore from '../store/dashboardStore';

const StatsGrid = () => {
  const { stats } = useDashboardStore();

  const statsConfig = [
    {
      title: 'Revenue Today',
      value: `$${stats.revenue.toLocaleString()}`,
      change: '+12.5%',
      icon: '💰',
      positive: true,
    },
    {
      title: 'Monthly Profit',
      value: `$${stats.monthlyProfit.toLocaleString()}`,
      change: '+8.2%',
      icon: '📈',
      positive: true,
    },
    {
      title: 'Products Analyzed',
      value: stats.productsAnalyzed.toLocaleString(),
      change: '+147',
      icon: '📦',
      positive: true,
    },
    {
      title: 'AI Performance',
      value: `${stats.aiPerformance}%`,
      change: '+2.1%',
      icon: '🤖',
      positive: true,
    },
  ];

  return (
    <div className="stats-grid">
      {statsConfig.map((stat, index) => (
        <div key={index} className="stat-card">
          <div className="stat-header">
            <span className="stat-title">{stat.title}</span>
            <span className="stat-icon">{stat.icon}</span>
          </div>
          <div className="stat-value">{stat.value}</div>
          <div className={`stat-change ${!stat.positive ? 'negative' : ''}`}>
            <span>{stat.change}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;